import { ActionReducerMap } from '@ngrx/store';

import * as fromEntity from './auth-group.reducer';
import { IAuthGroupSharedState } from './interfaces';

export * from './auth-group.messages';

export const reducers: ActionReducerMap<IAuthGroupSharedState> = {
  entityState: fromEntity.paginatedEntityStateReducer,
};
